export default "__VITE_ASSET__6474e985__"